export const shuffleArray = (array) => {
    for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
    }
    return array;
};

export const getOS = () => {
    let userAgent = window.navigator.userAgent,
        platform = window.navigator.platform,
        macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
        windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
        iosPlatforms = ['iPhone', 'iPad', 'iPod'],
        os = 'unknown';

    if (macosPlatforms.indexOf(platform) !== -1) {
        os = 'Mac OS';
    } else if (iosPlatforms.indexOf(platform) !== -1) {
        os = 'iOS';
    } else if (windowsPlatforms.indexOf(platform) !== -1) {
        os = 'Windows';
    } else if (/Android/.test(userAgent)) {
        return 'Android';
    } else if (!os && /Linux/.test(platform)) {
        os = 'Linux';
    }

    return os;
}

export const getBrowser = () => {
    if ((navigator.userAgent.indexOf("Opera") || navigator.userAgent.indexOf('OPR')) !== -1) {
        return 'Opera'
    }
    else if (navigator.userAgent.indexOf("Chrome") !== -1) {
        return 'Chrome'
    }
    else if (navigator.userAgent.indexOf("Safari") !== -1) {
        return 'Safari'
    }
    else if (navigator.userAgent.indexOf("Firefox") !== -1) {
        return 'Firefox'
    }
    else if ((navigator.userAgent.indexOf("MSIE") !== -1) || (!!document.documentMode)) //IF IE > 10
    {
        return 'IE'
    }
    else {
        return 'unknown'
    }
}

export const isSafariOrIOS = () => {
    const ua = navigator.userAgent.toLowerCase();
    return (ua.includes('safari') && !ua.includes('chrome')) || ua.includes('iphone') || ua.includes('ipad');
};

export const getAudioUrl = (audioName) => {

    if(isEmpty(audioName)) return null;

    return process.env.REACT_APP_CLOUDFRONT_DNS + "/media/audios/" + audioName;
}

export const getImageUrl = (imageName) => {
    if (imageName !== null && imageName !== undefined) {
        return process.env.REACT_APP_CLOUDFRONT_DNS + "/media/images/" + imageName;
    }
    return null;
};

export const getVideoUrl = (videoName) => {
    if (isEmpty(videoName)) return null;
    return "https://player.vimeo.com/video/" + videoName;
};

export const isEmpty = (value) => {
    // Null or Undefined
    if (value === null || value === undefined) {
      return true;
    }
  
    // Empty String
    if (typeof value === 'string' && value.trim() === '') {
      return true;
    }
  
    // Empty Array
    if (Array.isArray(value) && value.length === 0) {
      return true;
    }
  
    // Empty Object
    if (typeof value === 'object' && Object.keys(value).length === 0) {
      return true;
    }
  
    // If none of the above conditions match, it's not empty
    return false;
  };
